import { render, staticRenderFns } from "./OrderDrivers.vue?vue&type=template&id=5c0c5c5c&scoped=true"
import script from "./OrderDrivers.vue?vue&type=script&lang=js"
export * from "./OrderDrivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0c5c5c",
  null
  
)

export default component.exports